import React from 'react'
import styled from 'styled-components'
import { SettingsConsumer } from 'contexts/settings-context'
import { themes } from 'contexts/theme-context'

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`

const ItemsList = styled.ul`
  display: flex;
  justify-content: center;
  flex-flow: row;
  flex-wrap: wrap;
  padding: 0;
  margin: 24px 0 32px 0;
`

const LogoWrapper = styled.li`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px;
`

function MobileLogos (props) {
  const themesToRender = Object.keys(themes).filter((theme) => themes[theme].showInNetworkNav === true)

  return (
    <SettingsConsumer>
      {settings => {
        return (
          <Wrapper>
            <ItemsList>
              {
                themesToRender.map((themeName, index) => {
                  const logo = themes[themeName].footerLogoItems.mobileLogo
                  return (
                    <LogoWrapper key={`Mobile-footer-logos-${index}-${themeName}`}>
                      <a href={logo.url}>
                        <img src={`${settings.HOSTNAME}${logo.image}`} width="32px" />
                      </a>
                    </LogoWrapper>
                  )
                })
              }
            </ItemsList>
          </Wrapper>
        )
      }}
    </SettingsConsumer>
  )
}

export default MobileLogos



// WEBPACK FOOTER //
// ./src/organisms/Footer/components/MobileLogos.js